import { Avatar, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import { Spinner } from "components/shared/Spinner";

import type { CommandPaletteCompany } from "./useCommandPaletteState";

type Props = {
    companies: CommandPaletteCompany[];
    companySettings: any;
    query: string;
    totalCount: number;
    isLoading: boolean;
    onSelectCompany: (companyId: number) => void;
    t: (key: string) => string;
};

export const CompanyResultsList = ({
    companies,
    companySettings,
    query,
    totalCount,
    isLoading,
    onSelectCompany,
    t,
}: Props) => {
    if (isLoading) {
        return (
            <div className="command-palette__empty">
                <Spinner sx={{ transform: "scale(0.6)" }} />
            </div>
        );
    }

    return (
        <li>
            {!query.trim() && totalCount > 0 && (
                <div className="command-palette__section-header">
                    {totalCount} {t("CommandPalette.Companies")}
                </div>
            )}
            <ul>
                {companies.map((company) => (
                    <ListItemButton
                        key={company.id}
                        onClick={() => onSelectCompany(company.id)}
                        selected={company.id === companySettings?.id}
                        className="command-palette__item"
                    >
                        <ListItemAvatar>
                            <Avatar src={company.avatarUrl ?? ""} sx={{ width: 32, height: 32, fontSize: 14 }}>
                                {company.name[0]?.toUpperCase()}
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={company.name}
                            secondary={`${company.publisherType ?? ""} • #${company.id}`}
                            className="command-palette__item-text"
                        />
                        <button className="command-palette__item-navigate">{t("CommandPalette.ChangeCompany")}</button>
                    </ListItemButton>
                ))}
                {companies.length === 0 && query.trim() && (
                    <div className="command-palette__empty">{t("CommandPalette.SearchCompany")}</div>
                )}
            </ul>
        </li>
    );
};
